import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/coupon';

export default {
	// Coupon List
	getCoupons(params, cb, errorCb) {
		const query = buildQuery(params);
		const endpoint = `/coupon?${query}`;
		client.get(endpoint)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Create a New Coupon
	createCoupon(params, cb, errorCb) {
		const url = '/coupon';
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Update an Existing Coupon
	updateCoupon(id, params, cb, errorCb) {
		const url = `/coupon/${id}`;

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Bulk Update Status Coupon
	bulkUpdateStatus(params, cb, errorCb) {
		const url = '/coupon/status';
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	// Delete Single Coupon
	deleteCoupon(couponId, cb, errorCb) {
		const url = `/coupon/${couponId}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	// Bulk Delete Coupon
	bulkDelete(ids = [], cb, errorCb) {
		const url = '/coupon';

		const idsJSON = JSON.stringify(ids);
		const params = {
			coupon_ids: idsJSON,
		};

		client.delete(url, { data: params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Validate Coupon
	 * @param {Object} params Params
	 * @param {string} params.coupon_code Coupon Code
	 * @param {string} params.product_id Product ID
	 * @param {number} params.shipping_cost Shipping Cost
	 * @param {number} params.quantity Quantity
	 * @param {Object} [params.variation] Variation
	 * @param {Object[]} [params.variations] Variations
	 * @param {Boolean} [params.ignore_quota] Ignore Coupon Quota
	 * @param {requestCallback} cb Callback
	 * @param {errorCallback} errorCb Error Callback
	 */
	validate(params, cb, errorCb) {
		const url = `${endpoint}/validate`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Validate Coupon Storefront
	 * @param {Object} params Params
	 * @param {string} params.coupon_code Coupon Code
	 * @param {number} params.shipping_cost Shipping Cost
	 * @param {number} params.quantity Quantity
	 * @param {Object[]} [params.cart_items] Variations
	 * @param {Boolean} [params.ignore_quota] Ignore Coupon Quota
	 * @param {requestCallback} cb Callback
	 * @param {errorCallback} errorCb Error Callback
	 */
	validateStorefront(username, params, cb, errorCb) {
		const url = `https://public.orderonline.id/storefront/${username}${endpoint}/validate`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
